import type UserStore from '~store/UserStore';

export const canViewCompanyOnboarding = (userStore: UserStore) =>
  userStore.getAccess().settingsTab;

export const canManageCompanyOnboarding = (userStore: UserStore) =>
  canViewCompanyOnboarding(userStore) && userStore.getPermissions().canEditCompany;
